import { CheckSquare } from "lucide-react";
import { PageHeader } from "@/components/Layout/PageHeader";
import { TaskManager } from "./TaskManager";

export function TasksPage() {
  return (
    <div>
      <PageHeader
        icon={CheckSquare}
        title="Tasks"
        description="Track your to-do items, deadlines, and team assignments in one place. Stay on top of pending work across all your active campaigns and press activities."
      />
      <TaskManager />
    </div>
  );
}
